import { render, staticRenderFns } from "./LPCreate.vue?vue&type=template&id=f52549ee&"
import script from "./LPCreate.vue?vue&type=script&lang=js&"
export * from "./LPCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports